import ApplicationAdapter from "./application";

export default class LoadBalancerAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/loadbalancer/create`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/loadbalancer/edit?loadbalancerid=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/loadbalancer/destroy?loadbalancerid=${id}`;
  }
}
